import { Link } from 'react-router-dom';
import { categories, navLinks, site } from '@/mocks/site';
import { articles } from '@/mocks/articles';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const popular = articles.slice(0, 4);

  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-article-line text-xl"></i>
              </span>
              <div>
                <strong className="block font-heading text-lg font-bold text-background-50">
                  {site.name}
                </strong>
                <span className="text-[11px] tracking-widest text-primary-200">{site.slogan}</span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-primary-100/90">
              专注「网曝黑料」类事件的整理归档，把零散的爆料帖、录音与聊天记录，还原成一条看得懂的时间线。
            </p>
            <a
              href={`mailto:${site.email}`}
              className="mt-5 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
            >
              <i className="ri-mail-line"></i>
              {site.email}
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/" className="hover:text-accent-300 transition-colors">
                站内导航
              </Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {navLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-primary-100/90 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-primary-100/90 hover:text-accent-300 transition-colors">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/collections" className="hover:text-accent-300 transition-colors">
                热门分类
              </Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/collections?cat=${cat.id}`}
                    className="text-primary-100/90 hover:text-accent-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">
              <Link to="/timeline" className="hover:text-accent-300 transition-colors">
                最新归档
              </Link>
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {popular.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/article/${item.slug}`}
                    className="line-clamp-2 text-primary-100/90 hover:text-accent-300 transition-colors"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-700/60 pt-6">
          <p className="text-xs leading-relaxed text-primary-200">
            {site.disclaimer}
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <span className="text-xs text-primary-200">
              © {year} {site.name} · 内容整理自公开网络信息
            </span>
            <span className="text-xs text-primary-200">
              本站为资讯整理展示，人物均以身份代称呈现
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}